import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"

import getExistingUserAccessOptions from "./user-access-options"
import FieldConfig from "../../../../fields3/proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import {
    ProjectAccess,
    ProjectAccessDescriptionDictionary,
    ProjectAccessLabelDictionary
} from "../../../../gd/const/project"
import {featureAccess} from "../../../../gd/access-control/feature-access/feature-access";
import {Feature} from "../../../../gd/access-control/feature-access/const";

export default class FieldProjectAccess extends FieldDropdown {

    public minAccess?: ProjectAccess

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Project Access";
        this.typeGroup          = GROUP_INFO

        this.noValueOption      = false;

        this.options            = _.get(config, 'options', [
            {value: ProjectAccess.FULL,         label: ProjectAccessLabelDictionary[ProjectAccess.FULL],        description: ProjectAccessDescriptionDictionary[ProjectAccess.FULL]},
            {value: ProjectAccess.STANDARD,     label: ProjectAccessLabelDictionary[ProjectAccess.STANDARD],    description: ProjectAccessDescriptionDictionary[ProjectAccess.STANDARD]},
            {value: ProjectAccess.LIMITED,      label: ProjectAccessLabelDictionary[ProjectAccess.LIMITED],     description: ProjectAccessDescriptionDictionary[ProjectAccess.LIMITED]},

            {value: ProjectAccess.CLIENT,       label: ProjectAccessLabelDictionary[ProjectAccess.CLIENT],      description: ProjectAccessDescriptionDictionary[ProjectAccess.CLIENT],     notSelectable: true},
            {value: ProjectAccess.READ_ONLY,    label: ProjectAccessLabelDictionary[ProjectAccess.READ_ONLY],   description: ProjectAccessDescriptionDictionary[ProjectAccess.READ_ONLY]},
        ])

        this.minAccess          = _.get(config, 'minAccess', undefined)

        this.classes.PopoverMenu = 'max-w-250'
        this.classes.PopoverMenuScrollContainer = 'max-h-400'

        this.components.PopoverMenuMore = null
    }

    getOptionsForEdit(model:any) {
        const editOptions = _.clone(this.options)

        if (!model) {
            // strange ... hmmm
            // console.log("#49485 no model???")
            model = {}
        }

        const availableAccesses = getExistingUserAccessOptions(model[this.fieldId], model.projectUser, model.projectUsers);

        _.map(editOptions, (option:Option)=> {
            if (option.value === ProjectAccess.READ_ONLY) {
                option.disabled = (!availableAccesses.includes(option.value) || (this.minAccess && option.value < this.minAccess)) || !featureAccess(Feature.READ_ONLY)
            } else {
                option.disabled = !availableAccesses.includes(option.value) || (this.minAccess && option.value < this.minAccess)
            }
        })

        return editOptions || []
    }


    sortValue(value:any) {
        return value ? value : 0;
    }

}
